import { render, staticRenderFns } from "./subShare.vue?vue&type=template&id=294b79cf&scoped=true&"
import script from "./subShare.vue?vue&type=script&lang=js&"
export * from "./subShare.vue?vue&type=script&lang=js&"
import style0 from "./subShare.vue?vue&type=style&index=0&id=294b79cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b79cf",
  null
  
)

export default component.exports